// Channels routes (/channels/**) + ShareSignalModal.
export const channels: Record<string, string> = {
  // /channels marketplace
  'Subscribe to premium trading content from top traders': 'Pretplati se na premium trejding sadržaj najboljih trejdera',
  'Create Channel': 'Napravi kanal',
  'Search channels or traders…': 'Pretraži kanale ili trejdere…',
  'All groups': 'Sve grupe',
  'Paid': 'Plaćeno',
  'All': 'Sve',
  'Signals': 'Signali',
  'Analysis': 'Analiza',
  'Education': 'Edukacija',
  'Community': 'Zajednica',
  'Newest': 'Najnovije',
  'Most Subscribers': 'Najviše pretplatnika',
  'Highest Earning': 'Najveća zarada',
  'Lowest Price': 'Najniža cena',
  'Highest Price': 'Najviša cena',
  'No channels match your search': 'Nijedan kanal ne odgovara pretrazi',
  'No paid groups yet': 'Još nema plaćenih grupa',
  'No free channels yet': 'Još nema besplatnih kanala',
  'No channels in this category yet': 'Još nema kanala u ovoj kategoriji',
  'Channels launching soon': 'Kanali uskoro stižu',
  'Try a different search term or browse all categories': 'Probaj drugi pojam pretrage ili pregledaj sve kategorije',
  'Top-performing traders will be able to create premium channels. Subscribe to get real-time signals, analysis, and exclusive trade ideas.': 'Najuspešniji trejderi moći će da prave premium kanale. Pretplati se i dobijaj signale u realnom vremenu, analize i ekskluzivne trejd ideje.',
  'Create a Channel': 'Napravi kanal',
  'What to expect': 'Šta te očekuje',
  'Daily EUR/USD, GBP/USD setups with exact entry, SL & TP levels.': 'Dnevni EUR/USD i GBP/USD setapi sa tačnim Entry, SL i TP nivoima.',
  'Deep-dive BTC & ETH technical analysis with weekly outlook reports.': 'Detaljna tehnička analiza BTC i ETH sa nedeljnim izveštajima.',
  'Learn risk management, position sizing, and chart reading from scratch.': 'Nauči upravljanje rizikom, veličinu pozicije i čitanje grafikona od nule.',
  'Discuss S&P 500, NASDAQ, and DAX setups with fellow traders.': 'Diskutuj o S&P 500, NASDAQ i DAX setapima sa drugim trejderima.',
  '/month': '/mesečno',
  '/mo': '/mes',
  ' / month': ' / mesečno',
  'subscribers': 'pretplatnika',
  'posts': 'objava',
  'Featured Premium': 'Izdvojeni premium',
  'Premium': 'Premium',
  'Yours': 'Tvoj',
  'Your channel': 'Tvoj kanal',
  'Subscribe →': 'Pretplati se →',
  'View →': 'Pogledaj →',

  // /channels/create
  'Build your premium trading community': 'Napravi svoju premium trejding zajednicu',
  'Basic Info': 'Osnovni podaci',
  'Channel Name *': 'Naziv kanala *',
  'e.g. Pro Forex Signals': 'npr. Pro Forex Signali',
  'Description': 'Opis',
  "Tell subscribers what they'll get from your channel...": 'Reci pretplatnicima šta dobijaju od tvog kanala...',
  'Category': 'Kategorija',
  'Images (optional)': 'Slike (opciono)',
  'Profile Image URL': 'URL profilne slike',
  'Banner Image URL': 'URL baner slike',
  'Pricing': 'Cenovnik',
  'Monthly membership price': 'Mesečna cena članstva',
  'Subscribers are billed monthly (auto-renewing). You keep 90%.': 'Pretplatnici se naplaćuju mesečno (automatska obnova). Tebi ostaje 90%.',
  'Allow free preview posts': 'Dozvoli besplatne preview objave',
  'Non-subscribers can see preview content': 'Korisnici bez pretplate mogu da vide preview sadržaj',
  'Creating…': 'Kreiranje…',
  'Channel name is required': 'Naziv kanala je obavezan',
  'Please select a monthly membership price': 'Izaberi mesečnu cenu članstva',
  'Failed to create channel': 'Kreiranje kanala nije uspelo',
  'Something went wrong. Please try again.': 'Nešto je pošlo po zlu. Pokušaj ponovo.',

  // /channels/[id]/edit
  'Edit Channel': 'Izmeni kanal',
  'Update your channel settings': 'Ažuriraj podešavanja kanala',
  'e.g. Gold Signals Pro': 'npr. Gold Signali Pro',
  'Describe what subscribers will get...': 'Opiši šta pretplatnici dobijaju...',
  'Monthly Price (USD)': 'Mesečna cena (USD)',
  'Please enter a valid monthly price': 'Unesi ispravnu mesečnu cenu',
  'Failed to update channel': 'Ažuriranje kanala nije uspelo',
  'Channel updated successfully! Redirecting…': 'Kanal je uspešno ažuriran! Preusmeravanje…',
  'Saving…': 'Čuvanje…',
  'Save Changes': 'Sačuvaj izmene',
  'Danger Zone': 'Opasna zona',
  'Permanently delete this channel. This can’t be undone. A channel with subscribers can’t be deleted here (contact support to wind it down safely).': 'Trajno obriši ovaj kanal. Ovo se ne može poništiti. Kanal sa pretplatnicima ne može ovde da se obriše (kontaktiraj podršku da se bezbedno ugasi).',
  'Delete channel': 'Obriši kanal',
  'Type the channel name': 'Ukucaj naziv kanala',
  'to confirm:': 'da potvrdiš:',
  'Deleting…': 'Brisanje…',
  'Permanently delete': 'Trajno obriši',
  'Failed to delete channel': 'Brisanje kanala nije uspelo',

  // /channels/[id]/post
  'Create Post': 'Nova objava',
  'Post Content *': 'Sadržaj objave *',
  'Share your trading insight, signal, or analysis...': 'Podeli svoj trejding uvid, signal ili analizu...',
  'Image URL (optional)': 'URL slike (opciono)',
  'https://... or paste from Image Library': 'https://... ili nalepi iz biblioteke slika',
  'Premium Content': 'Premium sadržaj',
  'Only visible to active subscribers': 'Vidljivo samo aktivnim pretplatnicima',
  'Publishing…': 'Objavljivanje…',
  'Publish Post': 'Objavi',
  'Post content is required': 'Sadržaj objave je obavezan',
  'Failed to create post': 'Kreiranje objave nije uspelo',

  // /channels/[id]/join
  'Taking you to secure checkout…': 'Vodimo te na sigurno plaćanje…',

  // /channels/[id]
  'Payment successful!': 'Plaćanje uspešno!',
  'Your subscription is now active. Welcome to the channel!': 'Tvoja pretplata je sada aktivna. Dobro došao na kanal!',
  'Checkout was canceled. You can try again anytime.': 'Plaćanje je otkazano. Možeš pokušati ponovo bilo kad.',
  'Channel Suspended': 'Kanal je suspendovan',
  'Reason:': 'Razlog:',
  'This channel is hidden from public discovery. Contact support for assistance.': 'Ovaj kanal je sakriven iz javne pretrage. Kontaktiraj podršku za pomoć.',
  'Copy link': 'Kopiraj link',
  'Link copied!': 'Link kopiran!',
  'Copy the channel link:': 'Kopiraj link kanala:',
  'Dashboard': 'Kontrolna tabla',
  'New Post': 'Nova objava',
  'Track record:': 'Učinak:',
  'win': 'uspešnost',
  'No signals yet.': 'Još nema signala.',
  'Live signals are for subscribers': 'Live signali su za pretplatnike',
  'Subscribe to get every signal in real time. Closed results are shown publicly above.': 'Pretplati se i dobijaj svaki signal u realnom vremenu. Zatvoreni rezultati su javno prikazani iznad.',
  'Subscribe': 'Pretplati se',
  'Posts': 'Objave',
  'No posts yet.': 'Još nema objava.',
  'Create your first post': 'Napravi prvu objavu',
  'Performance Track Record': 'Istorija učinka',
  'Latest:': 'Poslednje:',
  'Return': 'Prinos',
  'Win Rate': 'Uspešnost',
  'Trades': 'Trejdovi',
  'Max Drawdown': 'Maks. drawdown',
  'Not Verified': 'Nije verifikovano',
  'Self-Reported': 'Samoprijavljeno',
  'Broker Verified': 'Verifikovao broker',
  'Platform Verified': 'Verifikovala platforma',
  'This performance data is self-reported by the trader and has not been independently verified.': 'Ove podatke o učinku je prijavio sam trejder i nisu nezavisno verifikovani.',
  'This performance data has not been verified.': 'Ovi podaci o učinku nisu verifikovani.',
  'This performance data has been verified against broker records.': 'Ovi podaci o učinku su verifikovani prema evidenciji brokera.',
  'This performance data has been verified by the ShowMeTrade platform.': 'Ove podatke o učinku je verifikovala ShowMeTrade platforma.',
  'Past performance is not indicative of future results. Results may be self-reported unless marked verified.': 'Prošli rezultati nisu garancija budućih. Rezultati mogu biti samoprijavljeni osim ako su označeni kao verifikovani.',
  'Hide': 'Sakrij',
  'View': 'Prikaži',
  'Performance History': 'istoriju učinka',
  'periods': 'perioda',
  'Period': 'Period',
  'Verification': 'Verifikacija',
  'Past performance is not indicative of future results. Always manage your own risk.': 'Prošli rezultati nisu garancija budućih. Uvek upravljaj sopstvenim rizikom.',
  'About the Trader': 'O trejderu',
  'Joined': 'Član od',
  'Subscribers': 'Pretplatnici',
  'Frequency': 'Učestalost',
  'Very Active': 'Veoma aktivan',
  'Active': 'Aktivan',
  'Occasional': 'Povremeno',
  'New': 'Novo',
  'premium': 'premium',
  'Risk & Compliance Disclosure': 'Obaveštenje o riziku i usklađenosti',
  'Educational Disclaimer': 'Edukativno upozorenje',
  'Content is for': 'Sadržaj služi',
  'educational and informational purposes only': 'isključivo u edukativne i informativne svrhe',
  '— not financial advice.': '— nije finansijski savet.',
  'No profits are guaranteed.': 'Profit nije garantovan.',
  'Trading involves significant risk of loss.': 'Trgovanje nosi značajan rizik od gubitka.',
  'Past performance is not indicative of future results.': 'Prošli rezultati nisu garancija budućih.',
  'Results may be self-reported unless explicitly marked as verified.': 'Rezultati mogu biti samoprijavljeni osim ako su izričito označeni kao verifikovani.',
  'Always conduct your own research and': 'Uvek uradi sopstveno istraživanje i',
  'manage your own risk': 'upravljaj sopstvenim rizikom',
  'before making any trading decisions.': 'pre bilo kakve trejding odluke.',
  'Cancels at Period End': 'Prestaje na kraju perioda',
  'Subscription Canceled': 'Pretplata otkazana',
  'Access until': 'Pristup do',
  'expiry': 'isteka',
  'Premium content will be locked after this date.': 'Premium sadržaj će biti zaključan posle ovog datuma.',
  'Processing…': 'Obrada…',
  'Resubscribe': 'Pretplati se ponovo',
  'Opening…': 'Otvaranje…',
  'Manage': 'Upravljaj',
  'Active Subscription': 'Aktivna pretplata',
  'Member since': 'Član od',
  'Renews': 'Obnavlja se',
  'Billed monthly via Stripe': 'Naplata mesečno preko Stripe-a',
  'Full access to all premium posts': 'Pun pristup svim premium objavama',
  'Subscriber-only analysis & signals': 'Analize i signali samo za pretplatnike',
  'Locked content unlocked': 'Zaključani sadržaj otključan',
  'Canceling…': 'Otkazivanje…',
  'Cancel Subscription': 'Otkaži pretplatu',
  'Manage Billing': 'Upravljaj naplatom',
  'Free Channel': 'Besplatan kanal',
  'Subscribe free to access all content': 'Pretplati se besplatno za pristup svom sadržaju',
  '-day free trial · then recurring monthly · Cancel anytime': '-dnevni besplatni probni period · zatim mesečna pretplata · Otkaži bilo kad',
  'Recurring monthly · Cancel anytime': 'Mesečna pretplata · Otkaži bilo kad',
  'Subscribing…': 'Pretplaćivanje…',
  'Redirecting…': 'Preusmeravanje…',
  'Subscribe Free': 'Pretplati se besplatno',
  'Try': 'Probaj',
  'days free': 'dana besplatno',
  'Access all premium posts': 'Pristup svim premium objavama',
  'Locked content unlocked instantly': 'Zaključani sadržaj se odmah otključava',
  'Secure payment via Stripe · Cancel anytime': 'Sigurno plaćanje preko Stripe-a · Otkaži bilo kad',
  'Pay on Stripe →': 'Plati preko Stripe-a →',
  'Opens Stripe in a new tab — sign in here afterwards to unlock the channel.': 'Otvara Stripe u novom tabu — posle se prijavi ovde da otključaš kanal.',
  'Subscribe to unlock': 'Pretplati se da otključaš',
  'Subscribe to unlock premium analysis': 'Pretplati se da otključaš premium analize',
  'Failed to start checkout': 'Pokretanje plaćanja nije uspelo',
  'Failed to subscribe': 'Pretplata nije uspela',
  'Failed to cancel': 'Otkazivanje nije uspelo',
  'Failed to open billing portal': 'Otvaranje portala za naplatu nije uspelo',

  // /channels/[id]/dashboard
  'Creator Dashboard': 'Kontrolna tabla kreatora',
  'Draft': 'Nacrt',
  'Published': 'Objavljeno',
  'Paid Ready': 'Spremno za naplatu',
  'Suspended': 'Suspendovan',
  'Not Started': 'Nije započeto',
  'In Review': 'Na proveri',
  'Enabled': 'Omogućeno',
  'Restricted': 'Ograničeno',
  'Expired': 'Isteklo',
  'Canceling': 'Otkazuje se',
  'New Subscription': 'Nova pretplata',
  'Renewal': 'Obnova',
  'Cancellation': 'Otkazivanje',
  'Payment Failed': 'Plaćanje nije uspelo',
  'Resubscribed': 'Ponovna pretplata',
  'Returned from Stripe Connect': 'Povratak sa Stripe Connect-a',
  'Syncing your account status…': 'Sinhronizacija statusa naloga…',
  'Your Stripe Connect status has been updated. Check the Setup tab for details.': 'Tvoj Stripe Connect status je ažuriran. Pogledaj karticu Podešavanje za detalje.',
  'Onboarding link expired': 'Link za registraciju je istekao',
  'Your onboarding link has expired. Click "Resume Onboarding" to get a new link.': 'Tvoj link za registraciju je istekao. Klikni „Nastavi registraciju“ za novi link.',
  'Channel not ready for paid launch': 'Kanal nije spreman za plaćeni start',
  'Complete the setup checklist to enable paid subscriptions.': 'Završi listu podešavanja da omogućiš plaćene pretplate.',
  'items done.': 'stavki gotovo.',
  '⚠ Stripe Connect onboarding required to receive payouts': '⚠ Stripe Connect registracija je obavezna za prijem isplata',
  'View Setup →': 'Pogledaj podešavanje →',
  'Payments go through an external link': 'Plaćanje ide preko eksternog linka',
  'Subscribe opens': 'Pretplati se otvara',
  'directly — Stripe Connect is not needed for this channel. New subscribers need manual access (Subscribers tab, or grant a trial).': 'direktno — Stripe Connect nije potreban za ovaj kanal. Novim pretplatnicima treba ručno dodeliti pristup (tab Subscribers, ili dodeli trial).',
  'Send this link — signed-in visitors go straight to your external payment link. Access unlocks manually after they pay (Subscribers tab).': 'Pošalji ovaj link — ulogovani posetioci idu direktno na tvoj eksterni link za plaćanje. Pristup se otključava ručno nakon uplate (tab Subscribers).',
  'Overview': 'Pregled',
  'Events': 'Događaji',
  'Performance': 'Učinak',
  'Setup': 'Podešavanje',
  '✓ Setup': '✓ Podešavanje',
  'Shareable join link': 'Link za pridruživanje',
  'Send this link — it takes people straight to secure checkout and unlocks the channel the moment they subscribe.': 'Pošalji ovaj link — vodi ljude direktno na sigurno plaćanje i otključava kanal čim se pretplate.',
  'Copied': 'Kopirano',
  'Stripe Connect Payouts': 'Stripe Connect isplate',
  'Account:': 'Nalog:',
  'Not connected': 'Nije povezano',
  'Resume Onboarding': 'Nastavi registraciju',
  'Connect Stripe': 'Poveži Stripe',
  'Sync': 'Sinhronizuj',
  'Payouts': 'Isplate',
  'Charges': 'Naplate',
  'Disabled': 'Onemogućeno',
  'Total': 'Ukupno',
  'Monthly Revenue': 'Mesečni prihod',
  'Gross Revenue': 'Bruto prihod',
  'Platform Fee': 'Provizija platforme',
  'Your Estimate': 'Tvoja procena',
  'Monthly recurring': 'Mesečno ponavljajuće',
  'fee': 'provizija',
  'After platform fee': 'Posle provizije platforme',
  'Lifetime Earnings': 'Ukupna zarada',
  'Gross': 'Bruto',
  'Your Net': 'Tvoj neto',
  'Connect Stripe to enable actual payouts': 'Poveži Stripe da omogućiš stvarne isplate',
  'Setup →': 'Podesi →',
  'Content': 'Sadržaj',
  'Total Posts': 'Ukupno objava',
  'Recent Events': 'Nedavni događaji',
  'View all →': 'Prikaži sve →',
  'Your Posts': 'Tvoje objave',
  'Subscriber Management': 'Upravljanje pretplatnicima',
  'No subscribers yet.': 'Još nema pretplatnika.',
  'Subscriber': 'Pretplatnik',
  'Status': 'Status',
  'Started': 'Počelo',
  'Access Until': 'Pristup do',
  'Email': 'Email',
  'Send welcome email': 'Pošalji welcome mejl',
  'Sending…': 'Šaljem…',
  'Sent': 'Poslato',
  'User': 'Korisnik',
  'Ongoing': 'U toku',
  'Subscription Event History': 'Istorija događaja pretplata',
  'No events yet.': 'Još nema događaja.',
  'Drafts': 'Nacrti',
  'Verified': 'Verifikovano',
  'Avg Return': 'Prosečan prinos',
  'Performance records you publish will be visible on your public channel page. All records are clearly labeled with their verification status. Past performance is not indicative of future results.': 'Zapisi o učinku koje objaviš biće vidljivi na javnoj stranici kanala. Svi zapisi su jasno označeni statusom verifikacije. Prošli rezultati nisu garancija budućih.',
  'Performance Records': 'Zapisi o učinku',
  'Add Period Result': 'Dodaj rezultat perioda',
  'Edit Performance Entry': 'Izmeni zapis učinka',
  'New Performance Entry': 'Novi zapis učinka',
  'Period Start *': 'Početak perioda *',
  'Period End *': 'Kraj perioda *',
  'Return % *': 'Prinos % *',
  'Win Rate % (optional)': 'Uspešnost % (opciono)',
  'Total Trades (optional)': 'Ukupno trejdova (opciono)',
  'Max Drawdown % (optional)': 'Maks. drawdown % (opciono)',
  'P&L Amount (optional)': 'P&L iznos (opciono)',
  'Verification Type': 'Tip verifikacije',
  'Notes (optional)': 'Napomene (opciono)',
  "Add context about this period's performance…": 'Dodaj kontekst o učinku ovog perioda…',
  'Period start, period end, and return % are required.': 'Početak perioda, kraj perioda i prinos % su obavezni.',
  'Failed to save entry': 'Čuvanje zapisa nije uspelo',
  'Save as Draft': 'Sačuvaj kao nacrt',
  'Publish': 'Objavi',
  'Unpublish': 'Povuci objavu',
  'Failed to update status': 'Ažuriranje statusa nije uspelo',
  'No performance records yet.': 'Još nema zapisa o učinku.',
  'Add your first period result to build your track record.': 'Dodaj prvi rezultat perioda da gradiš svoju istoriju učinka.',
  'Win Rate:': 'Uspešnost:',
  'Trades:': 'Trejdovi:',
  'Max DD:': 'Maks. DD:',
  'Launch Checklist': 'Lista za pokretanje',
  'complete': 'završeno',
  'Channel name set': 'Naziv kanala postavljen',
  'Description added': 'Opis dodat',
  'Profile image uploaded': 'Profilna slika postavljena',
  'Monthly price set': 'Mesečna cena postavljena',
  'Free channel (no price needed)': 'Besplatan kanal (cena nije potrebna)',
  'Disclaimer accepted': 'Upozorenje prihvaćeno',
  'Stripe Connect onboarding complete': 'Stripe Connect registracija završena',
  'Fix →': 'Ispravi →',
  'Channel is ready for paid launch!': 'Kanal je spreman za plaćeni start!',
  'Connect your Stripe account to receive payouts from paid subscriptions.': 'Poveži svoj Stripe nalog da primaš isplate od plaćenih pretplata.',
  'Platform fee:': 'Provizija platforme:',
  'Account ID': 'ID naloga',
  '✓ Enabled': '✓ Omogućeno',
  '⏳ Pending': '⏳ Na čekanju',
  'Onboarding': 'Registracija',
  '✓ Complete': '✓ Završeno',
  '⏳ Incomplete': '⏳ Nezavršeno',
  'Last attempt': 'Poslednji pokušaj',
  'Connect Stripe for Payouts': 'Poveži Stripe za isplate',
  'Stripe Connect active — payouts enabled': 'Stripe Connect aktivan — isplate omogućene',
  'Syncing…': 'Sinhronizacija…',
  'Sync Status': 'Sinhronizuj status',
  'Revenue Split Model': 'Model podele prihoda',
  'For each': 'Za svaku',
  'subscription:': 'pretplatu:',
  'Gross:': 'Bruto:',
  'Net': 'Neto',
  'SMT fee': 'SMT provizija',
  'Your net:': 'Tvoj neto:',
  'Creator Agreement & Disclaimer': 'Ugovor kreatora i upozorenje',
  'By enabling paid subscriptions, you agree to the following:': 'Omogućavanjem plaćenih pretplata prihvataš sledeće:',
  'All content is for': 'Sav sadržaj služi',
  'You will': 'Ti',
  'not guarantee profits': 'nećeš garantovati profit',
  'or specific trading outcomes': 'niti konkretne ishode trgovanja',
  'Past performance is': 'Prošli učinak',
  'not indicative of future results': 'nije garancija budućih rezultata',
  'Subscribers are responsible for': 'Pretplatnici su odgovorni za',
  'managing their own risk': 'upravljanje sopstvenim rizikom',
  'You will comply with all applicable laws and platform policies': 'Poštovaćeš sve važeće zakone i pravila platforme',
  'Agreement accepted': 'Ugovor prihvaćen',
  'I Agree — Accept Disclaimer': 'Slažem se — prihvatam upozorenje',
  'Deleting removes this channel. If it has subscribers, billing stops at the end of each paid period — members keep access until then and no one is charged again. A channel with no subscribers is deleted permanently.': 'Brisanje uklanja ovaj kanal. Ako ima pretplatnike, naplata prestaje na kraju svakog plaćenog perioda — članovi zadržavaju pristup do tada i niko se više ne naplaćuje. Kanal bez pretplatnika se briše trajno.',
  'Are you sure?': 'Da li si siguran?',
  'Yes, delete': 'Da, obriši',

  // ShareSignalModal
  'Share as Signal': 'Podeli kao signal',
  'Preparing your branded signal…': 'Pripremamo tvoj brendirani signal…',
  'Your referral link is baked into the QR — every scan & click is tracked': 'Tvoj referal link je ugrađen u QR — svako skeniranje i klik se prati',
  'to': 'za',
  'AUTO-POST': 'AUTO-OBJAVA',
  'SHARE TO': 'PODELI NA',
  'auto-broadcasts used today.': 'auto-objava iskorišćeno danas.',
  'Connect channels in Profile to auto-broadcast (coming soon).': 'Poveži kanale u Profilu za auto-objavu (uskoro).',
  'Copy image': 'Kopiraj sliku',
  'More': 'Više',
  'Download PDF (email / docs)': 'Preuzmi PDF (imejl / dokumenti)',
  'Send': 'Pošalji',
  'Schedule': 'Zakaži',
  'Scheduling is a Pro feature (coming soon)': 'Zakazivanje je Pro funkcija (uskoro)',
  'Link copied': 'Link kopiran',
  'Could not copy': 'Kopiranje nije uspelo',
  'Asset not ready': 'Materijal nije spreman',
  'Image copied': 'Slika kopirana',
  'Image copy unsupported — use Download': 'Kopiranje slike nije podržano — koristi Preuzmi',
  'Could not download image': 'Preuzimanje slike nije uspelo',
  'Daily auto-broadcast limit reached': 'Dostignut dnevni limit auto-objava',
  'Send failed': 'Slanje nije uspelo',
  'Connect these channels in Profile to auto-post: ': 'Poveži ove kanale u Profilu za auto-objavu: ',
  'Signal broadcast': 'Signal poslat',
  'Network error': 'Greška mreže',
  'Link copied (sharing unsupported here)': 'Link kopiran (deljenje ovde nije podržano)',
  'Image downloaded + caption copied — open Instagram and paste': 'Slika preuzeta + opis kopiran — otvori Instagram i nalepi',
  // linked broker account (2026-09-06)
  'Account results': 'Rezultati naloga',
  'Link one of your connected read-only accounts and its real results (net result, return, win rate, drawdown, last trades) appear on the channel page — like on FX Doctor\'s Gold.':
    'Poveži jedan od svojih read-only naloga i njegovi pravi rezultati (neto rezultat, prinos, win rate, pad, poslednji trejdovi) se prikazuju na strani kanala — kao na FX Doctor\'s Gold.',
  'No connected accounts yet.': 'Još nemaš povezan nalog.',
  'Connect an account →': 'Poveži nalog →',
  'Connect another account →': 'Poveži još jedan nalog →',
  '— not linked —': '— nije povezan —',
  'Show this account\'s results publicly on the channel page': 'Prikaži rezultate ovog naloga javno na strani kanala',
  'Only read-only data is shown; nobody can trade or withdraw. You can unlink at any time.': 'Prikazuju se samo read-only podaci; niko ne može da trguje ni da povlači novac. Vezu možeš da ukineš bilo kad.',
  'Share your win 🏆': 'Podeli pobedu 🏆',
  'hit Take Profit': 'pogodio Take Profit',
  'my public track record on ShowMeTrade': 'moj javni skor na ShowMeTrade',
};
